import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../context/AuthContext';
import { getSettings } from '../api/settings';

// Vendor-wide UI settings, shared by the vendor and all of its team members.
// Defaults to the full view until loaded (or if the request fails).
export default function useSettings() {
  const { user } = useAuth();
  const { data, isLoading } = useQuery({
    queryKey: ['vendor-settings', user?.vendorId],
    queryFn: () => getSettings().then((r) => r.data.data),
    enabled: !!user,
    staleTime: 60_000,
  });
  return { simpleView: data?.simpleView ?? false, isLoading };
}
